import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Sendgrid",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".cls-1{fill:#51a9e3}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "Icon_Updated_Keylines",
      "data-name": "Icon, Updated Keylines"
    }, [
      _createElementVNode("path", {
        d: "M21 1h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2 .9 2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V2c0-.55-.45-1-1-1zM11 31h8c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-6c-1.1 0-2-.9-2-2v-6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v17c0 .55.45 1 1 1z",
        class: "cls-1"
      })
    ], -1))
  ]))
}
export default { render: render }